import React from 'react'
import {Flex, Box, Text, Button, Link} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

import {DownloadIcon} from '../../../icons'

const iconStyle = {
  width: '1.5em',
  height: '1.5em',
}

const Action = ({icon, label}) => (
  <Flex alignItems="center" mr={{base: 2, lg: 5, xl: 10}}>
    <Text
      p={2}
      textTransform="uppercase"
      fontWeight={500}
      fontSize="sm"
      display={{base: 'none', md: 'block'}}
    >
      {label}
    </Text>
    {icon}
  </Flex>
)

Action.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
}

const Actions = ({statementPdfDownloadPath}) => {
  const {t} = useTranslation('payerStatements')

  const downloadUrl = new URL(statementPdfDownloadPath, window.location.origin)
  downloadUrl.searchParams.set('current', true)

  return (
    <Flex>
      {/* <Action
        label={t('invoices.sort')}
        icon={<SwapVerticalIcon style={iconStyle} />}
      />
      <Action
        label={t('invoices.filter')}
        icon={<FilterListIcon style={iconStyle} />}
      /> */}
      <Box display={{base: 'none', md: 'block'}}>
        <Button
          as="a"
          variant="secondary"
          colorScheme="primary"
          href={`${downloadUrl.toString()}`}
        >
          <>
            <DownloadIcon mr={2} style={iconStyle} />
            <Box as="span">{t('invoices.download')}</Box>
          </>
        </Button>
      </Box>
      <Box display={{base: 'block', md: 'none'}}>
        <Link href={statementPdfDownloadPath}>
          <DownloadIcon style={iconStyle} />
        </Link>
      </Box>
    </Flex>
  )
}

Actions.propTypes = {
  statementPdfDownloadPath: PropTypes.string.isRequired,
}

export default Actions
